import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import { type ShopModalMode } from './type';

type Props = { mode: ShopModalMode; children: ReactNode };

export const ShopContentSwitcher: FC<Props> = ({ mode, children }) => {
  return (
    <div className="overflow-x-hidden">
      <div
        className={classNames(
          'transition-transform duration-300 relative',
          { '-translate-x-full': mode === 'detail' },
          { '-translate-x-[200%]': mode === 'vjw' }
        )}
      >
        {children}
      </div>
    </div>
  );
};
